import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "categories",
  label: "Categories",
  description: "Category photo tiles, or a slim shortcut strip of top categories with a promo line.",
  supportedPages: ["home", "categories", "shop"],
  variants: [
    {
      id: "v1",
      label: "Photo tiles",
      fields: [
        { key: "subtitle", label: "Subtitle", type: "string" },
        {
          key: "columns",
          label: "Columns",
          type: "select",
          options: [
            { label: "2 Columns", value: 2 },
            { label: "3 Columns", value: 3 },
            { label: "4 Columns", value: 4 },
            { label: "5 Columns", value: 5 },
            { label: "6 Columns", value: 6 },
          ],
          default: 4,
        },
        { key: "emptyText", label: "Empty Text", type: "string", default: "No categories found." },
      ],
    },
    {
      id: "v2",
      label: "Shortcut strip",
      fields: [
        { key: "limit", label: "Categories shown", type: "number", default: 3, help: "Your first top-level categories." },
        { key: "promoText", label: "Promo line", type: "string", default: "Cash on delivery all over the country" },
        { key: "promoLink", label: "Promo link", type: "string", placeholder: "/shop" },
      ],
    },
  ],
  commonFields: [
    { key: "title", label: "Title (strip: the label on the left)", type: "string" },
    ...SECTION_STYLE_FIELDS,
  ],
};
